



const styles = {

  root: {
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 50,
  },

  title: {
    fontFamily: "'Montserrat', sans-serif",
    textAlign: 'center',
  },





};

export default styles;



// WEBPACK FOOTER //
// ./src/containers/successful_donation/styles.js